module.exports = __webpack_public_path__ + "static/media/michael-dam-mEZ3PoFGs_k-unsplash.4f5fec86.jpg";